import { AccountLessAuthClient } from '../account-less-auth-client';
import { Failed, Success } from '../request';
export class SmsChallengeRequest {
    constructor(baseUrl, request) {
        this.baseUrl = baseUrl;
        this.request = request;
    }
    async createChallenge(options) {
        const client = new AccountLessAuthClient(this.baseUrl);
        const response = await client.createChallenge(this.request, options);
        const body = await response.json();
        if (!response.ok) {
            return Failed(body);
        }
        const nonce = body.challenge?.nonce;
        if (!nonce) {
            throw new Error('Nonce was not returned from server');
        }
        const verify = async (code) => {
            const response = await client.verifyChallenge({
                ...this.request,
                challengeResponse: { nonce, code },
            }, options);
            const body = await response.json();
            if (!response.ok) {
                return Failed(body);
            }
            const token = body.token;
            if (!token) {
                throw new Error('Token was not returned from server');
            }
            return Success('token', body.token);
        };
        return Success('verify', verify);
    }
}
/** @public */
export class SmsOtp {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }
    withScope(scope) {
        this.scope = scope;
        return this;
    }
    withRequestFrom(requestFrom) {
        this.requestFrom = requestFrom;
        return this;
    }
    withPhoneNumber(countryCode, number) {
        this.phoneNumber = {
            number,
            countryCode,
        };
        return this;
    }
    withEmail(email) {
        this.email = email;
        return this;
    }
    build() {
        const request = {
            authFactor: 'SMS_OTP',
            scope: this.scope,
            requestFrom: this.requestFrom,
            payload: {
                phoneNumber: this.phoneNumber,
                email: this.email,
            },
        };
        return new SmsChallengeRequest(this.baseUrl, request);
    }
}
//# sourceMappingURL=sms-otp.js.map